import React, { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AddIcon, Header, Search, SearchIcon } from 'elmo-elements';

import {
  actions as MyElearningStateActions,
  MyElearningStateType,
} from '@/modules/reducers/myElearning';
import { pushParamsToUrl } from '@/lib/util';
import { useHistory, useLocation } from 'react-router-dom';
import { useUserHasCapabilities } from '@/lib/auth/useUserHasCapabilities';
import ElaPermissions from '@/lib/auth/permissions/permission.type';
import './Header.scss';

const MyElearningHeader = (): ReactElement => {
  const showNewModule = useUserHasCapabilities([
    ElaPermissions.CREATE_NEW_ELEARNING,
  ]);

  const initialSearch = Object.fromEntries(
    new URLSearchParams(useLocation().search).entries(),
  ).search;
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState(initialSearch);

  const dispatch = useDispatch();

  const myElearningState: MyElearningStateType = useSelector(
    (state: { myElearning: MyElearningStateType }) => state.myElearning,
  );

  const handleOpenNewModule = () => {
    dispatch({ type: MyElearningStateActions.openNewModule.type });
  };

  const handleOpenSearch = () => {
    dispatch({ type: MyElearningStateActions.openSearch.type });
  };

  const handleCloseSearch = () => {
    setSearchQuery('');
    pushParamsToUrl({ search: '', page: 1 }, history);
    dispatch({ type: MyElearningStateActions.closeSearch.type });
  };

  const handleSearchChange = (searchValue: string) => {
    setSearchQuery(searchValue);
    if (searchValue === '') pushParamsToUrl({ search: '', page: 1 }, history);
  };

  return (
    <header id="my-library-header">
      <Header
        title="My Library"
        primaryButton={
          showNewModule
            ? {
                id: 'btn-new-module',
                icon: <AddIcon />,
                label: 'New Module',
                onClick: handleOpenNewModule,
                isDisabled: false,
              }
            : undefined
        }
        isSearchOpen={myElearningState.isSearchOpen}
        buttons={[
          {
            id: 'btn-open-search',
            icon: <SearchIcon />,
            label: 'Open Search',
            onClick: handleOpenSearch,
            showBtnLabel: false,
            tooltip: 'Open Search',
          },
        ]}
      >
        <Search
          value={searchQuery}
          isVisible={myElearningState.isSearchOpen}
          onClose={handleCloseSearch}
          onChange={handleSearchChange}
          onSubmit={() => {
            pushParamsToUrl({ search: searchQuery, page: 1 }, history);
          }}
          isSubmitEnabledAlways={true}
        />
      </Header>
    </header>
  );
};

export default MyElearningHeader;
